import { useEffect, useRef, useState } from "react";
import "./CollapsibleHeader.scss";
import { use } from "react";

const CollapsibleHeader = ({
  title,
  defaultOpen = true,
  rightContent = null,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const bodyRef=useRef(null);


  useEffect(() => {
    if (open && bodyRef.current) {
      bodyRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start", // or "nearest"
      });
    }
  }, [open]);

  return (
    <div className="CollapsibleContainer">
      <div
        className="CollapsibleHeader"
        onClick={() => setOpen(!open)}
      >
        <span className={`Arrow ${open ? "open" : ""}`}>▾</span>
        <h3>{title}</h3>

        {rightContent && (
          <div
            className="RightContent"
            onClick={(e) => e.stopPropagation()}
          >
            {rightContent}
          </div>
        )}
      </div>



      {/* ✅ THIS IS THE REQUIRED CHANGE */}
      <div  ref = {bodyRef} className={`CollapsibleBody ${open ? "open" : ""}`}>
        <div className="CollapsibleInner">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CollapsibleHeader;
